const StatisticalEmp = () =>
  import('@/views/main/fubo/statisticalEmp/StatisticalEmp.vue')
export default {
  path: '/main/fubo/statisticalEmp',
  name: 'FuboStatisticalEmp',
  component: StatisticalEmp,
  children: []
}
